export const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const GbpEndpoints = {
    FetchReviewById: `/api/v1/gbp/reviews/:id`,
    ManageReviewReply: `/api/v1/gbp/reviews/:id/reply`,
    GenerateReviewReply: `/api/v1/gbp/reviews/:id/reply/generate`,
    SendInvitation: `/api/v1/gbp/reviews/:id/send-invitation`,
    getActionToken: `/api/v1/action-token`,
  };